export default __webpack_public_path__ + "static/button-c504df3eebdf1fc3ea62749f90ad5e65.svg";